export function isShareData(data: unknown): data is ShareData {
  if (typeof data === 'object' && data !== null) {
    const keys = ['files', 'url', 'text', 'title'];
    return keys.some(key => key in data);
  }
  return false;
}
